import styled from 'styled-components'
import Button from '../Button'

export const StyledButton = styled(Button)`
  margin-top: ${({ theme }) => theme.gutterMedium};
`

export const Modal = styled.div`
  background: ${({ theme }) => theme.themeColorPaleOpacity};
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
`

export const Content = styled.div`
  background: ${({ theme }) => theme.themeColorSecondary};
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: ${({ theme }) => theme.gutterMedium};
  border-radius: ${({ theme }) => theme.borderRadius};
`